/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import React from 'react';
import classNames from 'classnames';
import './index.scss';

const Loader = ({ message }) => {
  return (
    <div className="spinner-div text-center w-100 mt-4 mb-5">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
      <br />
      {message && <div className={'text-muted'}>{message}</div>}
    </div>
  );
};

export default Loader;

export const Spinner = ({ color = 'white' }) => (
  <div className={`spinner-border content-spinner  text-${color} spinner-border-sm`} />
);
export const OverlayLoader = ({ message, active, children, padding }) => {
  if (children) {
    return (
      <div
        className={classNames(
          {
            'loading-overlay': active,
            'no-loading-overlay': !active,
            'pb-3': padding,
          },
          'w-100'
        )}
      >
        <>{children}</>
        {active && (
          <div className="spinner-div text-center w-100">
            <div>
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <br />
              {message && <div className={'text-message'}>{message}</div>}
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div
        className={classNames({
          'loading-overlay': active,
          'no-loading-overlay': !active,
          'pb-3': padding,
        })}
        style={{ height: '20vh' }}
      >
        {active && (
          <div className="spinner-div text-center w-100">
            <div>
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <br />
              {message && <div className={'text-message'}>{message}</div>}
            </div>
          </div>
        )}
      </div>
    );
  }
};
